export default __webpack_public_path__ + "static/media/bim.120ceb58.png";